var data = [
    {
        roomname: 'Steady Seller',
        hasee: -1,
        roomlogo: 'roomlogo-steady.svg',
        introtext: '시간을 넘어 다 무신사랑 해',
        introtext2: '수많은 사람들의 선택이 가치를 증명합니다 꾸준한 사랑을 받아온 무신사 스테디셀러',
        tlblip_arr: [],
        contents: [
            {
                brandname: 'THISISNEVERTHAT',
                brandnamekr: '디스이즈네버댓',
                intro: `디스이즈네버댓(THISISNEVERTHAT)은 스포츠 앤 스트릿을 컨셉트로
                2010년에 론칭한 브랜드입니다.
                
                밀리터리 스타일과 1990년대 스포츠 웨어를 기반으로 현재의 무드를 담아 디자인합니다.
                매 시즌 사진과 영상 등을 통해 새로운 컬렉션을 발표하며,
                
                다양한 브랜드와 협업하며 스타일과 기능을 모두 반영한 디자인을 하고자 합니다.`,
                intromobile: `디스이즈네버댓(THISISNEVERTHAT)은 
                스포츠 앤 스트릿을 컨셉트로 2010년에 론칭한 
                브랜드입니다.
                
                밀리터리 스타일과 1990년대 스포츠 웨어를
                기반으로 현재의 무드를 담아 디자인합니다.
                매 시즌 사진과 영상 등을 통해
                새로운 컬렉션을 발표하며,
                
                다양한 브랜드와 협업하며 스타일과 기능을 모두 반영한 디자인을 하고자 합니다.`,
                hashtag: '#thisisneverthat #디스이즈네버댓 #디네댓 #스트릿',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/thisisneverthat',
            },
            {
                brandname: 'LAFUDGE STORE',
                brandnamekr: '라퍼지스토어',
                intro: `라퍼지스토어(LAFUDGESTORE)는 다양한 사람들이 일상에서 편안하게 
                사용할 수 있는 제품을 전개합니다.
                
                새롭게 변화되는 소재와 실루엣, 일상에 자연스레 스며드는 제품을 제작하여
                지속적인 실속형 소비의 가치를 실천합니다.`,
                intromobile: `라퍼지스토어(LAFUDGESTORE)는 다양한
                사람들이 일상에서 편안하게 
                사용할 수 있는 제품을 전개합니다.
                
                새롭게 변화되는 소재와 실루엣, 일상에 자연스레 스며드는 제품을 제작하여
                지속적인 실속형 소비의 가치를 실천합니다.`,
                hashtag: '#린넨팬츠 #오버핏셔츠 #여름니트 #린넨셋업',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/lafudgestore',
            },
            {
                brandname: 'LEE',
                brandnamekr: '리',
                intro: `리(LEE)는 캔자스 시티에서 시작된 130년 역사를 지닌 브랜드입니다.
                전통적으로 견고함과 실용성을 강조했던
                워크 웨어와 데님으로부터 모티브를 얻어 현대적이고 세련된 스타일을
                전개하는 라이프스타일 브랜드입니다.`,
                intromobile: `리(LEE)는 캔자스 시티에서 시작된 130년 역사를 지닌 브랜드입니다.

                전통적으로 견고함과 실용성을 강조했던
                워크 웨어와 데님으로부터 모티브를 얻어
                현대적이고 세련된 스타일을
                전개하는 라이프스타일 브랜드입니다.`,
                hashtag: '#트위치 #빅로고 #스몰로고',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/lee',
            },
            {
                brandname: 'MARDI MERCREDI',
                brandnamekr: '마르디메크르디',
                intro: `마르디 메크르디(MARDI MERCREDI)는 
                매 시즌 넘버링을 통해 아카이브화하고 나열된 아카이브를 통해 
                마르디 메크르디만의 간결하고 우아한 무드를 표현합니다.
                `,
                intromobile: `마르디 메크르디(MARDI MERCREDI)는 
                매 시즌 넘버링을 통해 아카이브화하고 
                나열된 아카이브를 통해 마르디 메크르디만의 
                간결하고 우아한 무드를 표현합니다.`,
                hashtag: '마르디 메크르디만의 간결하고 우아한 무드를 표현합니다.',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/mardimercredi',
            },
            {
                brandname: 'ADIDAS',
                brandnamekr: '아디다스',
                intro: `스포츠 라이프스타일은 라커룸 밖에서도 계속됩니다.

                1920년부터 독일의 헤르초게나우라흐에서 스포츠 슈즈를 만들던 아디다스(ADIDAS)는
                이러한 철학을 토대로 경기장에서부터 거리에 이르기까지
                모두가 즐길 수 있는 '스포츠 라이프스타일'의 개념을 처음으로 도입한 브랜드입니다.
                
                스포츠 영역의 다양한 요소를 일상의 영역으로 가져오는 아디다스는
                이를 통해 전 세계의 트렌드를 주도하고 있으며, 지금도 여전히 자신의 다양한 모습을
                보여주고 싶어하는 소비자와 직접 소통하며 함께 혁신적인 트렌드를 만들고 있습니다.`,
                intromobile: `스포츠 라이프스타일은 라커룸 밖에서도
                계속됩니다.
                
                1920년부터 독일의 헤르초게나우라흐에서
                스포츠 슈즈를 만들던 아디다스(ADIDAS)는
                이러한 철학을 토대로 경기장에서부터
                거리에 이르기까지 모두가 즐길 수 있는
                '스포츠 라이프스타일'의 개념을 처음으로
                도입한 브랜드입니다.
                
                스포츠 영역의 다양한 요소를 일상의 영역으로 
                가져오는 아디다스는 이를 통해 전 세계의
                트렌드를 주도하고 있으며,
                지금도 여전히 자신의 다양한 모습을
                보여주고 싶어하는 소비자와 직접 소통하며 함께 혁신적인 트렌드를 만들고 있습니다.`,
                hashtag: '#스니커즈  #신발 #독일군 #아디다스 #슈퍼스타 #포럼 #BW아미',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/adidas',
            },
            {
                brandname: 'YALE',
                brandnamekr: '예일',
                intro: `예일(YALE)은 미국 명문 사립대학 예일대학교(Yale University)의
                시그니처 패션을 선보이는 브랜드입니다.
                
                예일대학교의 시그니처 로고는 아이비리그 룩과 프레피 룩을 논할 때
                빼놓을 수 없는 아이콘으로 빈티지 웨어에 중요한 부분을 차지하고 있습니다. `,
                intromobile: `예일(YALE)은 미국 명문 사립대학
                예일대학교(Yale University)의
                시그니처 패션을 선보이는 브랜드입니다.
                
                예일대학교의 시그니처 로고는 아이비리그 룩과 프레피 룩을 논할 때 빼놓을 수 없는 아이콘으로
                빈티지 웨어에 중요한 부분을 차지하고 있습니다. `,
                hashtag: '#아이비리그 #프레피룩 #유니버시티 댄 #원마일웨어',
                logoformat: 'png',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/yale',
            },
            {
                brandname: 'CONVERSE',
                brandnamekr: '컨버스',
                intro: `컨버스(CONVERSE)는 미국 매사추세츠 주 보스턴에 자리한
                나이키의 자회사로 1908년에 설립해 전 세계의 다양한 문화를 아우르며
                개성을 표현하는 브랜드로 인정 받고 있습니다.
                
                척 테일러 올스타, 원스타, 잭 퍼셀 등의 상징적인 운동화의 재해석과
                새로운 시도도 지속적으로 이어 가고 있습니다.`,
                intromobile: `컨버스(CONVERSE)는 미국 매사추세츠 주
                보스턴에 자리한 나이키의 자회사로
                1908년에 설립해 전 세계의 다양한 문화를
                아우르며 개성을 표현하는 브랜드로
                인정 받고 있습니다.
                
                척 테일러 올스타, 원스타, 잭 퍼셀 등의 상징적인 운동화의 재해석과 새로운 시도도
                지속적으로 이어 가고 있습니다.`,
                hashtag: '#스니커즈 #척70 #컨버스 #CONVERSE',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/converse',
            },
            {
                brandname: 'POLO',
                brandnamekr: '폴로 랄프 로렌',
                intro: `폴로 랄프 로렌(POLO RALPH LAUREN)은 미국을 대표하는
                디자이너 랄프 로렌이 1967년에 시작한 브랜드입니다.
                
                폴로 랄프 로렌의 제품은 실용적이면서 품격을 갖춰
                꾸준한 인기와 사랑을 받고 있습니다.`,
                intromobile: `폴로 랄프 로렌(POLO RALPH LAUREN)은
                미국을 대표하는 디자이너 랄프 로렌이
                1967년에 시작한 브랜드입니다.
                
                폴로 랄프 로렌의 제품은 실용적이면서
                품격을 갖춰꾸준한 인기와 사랑을 받고 있습니다.`,
                hashtag: '#폴로 랄프 로렌 #POLO #POLO RALPH LAUREN',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/poloralphlauren',
            },
        ],
    },
    {
        roomname: 'Boutique',
        hasee: -1,
        roomlogo: 'roomlogo-boutique.svg',
        introtext: '무신사적 럭셔리 큐레이션',
        introtext2: '클래식, 하이엔드, 컨템포러리 그리고 스트릿까지 무신사가 엄선한 고감도 럭셔리',
        tlblip_arr: [],
        contents: [
            {
                brandname: 'MASSCOB',
                brandnamekr: '마스콥',
                intro: `마스콥(MASSCOB) 은 마르가 마사네트(Marga Massanet)와
                쟈코보 코비안(Jacobo Cobián)이 2003년 스페인의 라 꼬류냐에서 
                두 사람의 이름에서 착안하여 설립한 브랜드 입니다.
                
                 여성성과 남성성을 모두 가진 듀얼 퍼스널리티를 표방하는 이 브랜드는
                단순히 트렌드 만을 쫓지 않고, 두 설립자이자 디자이너의 직관에 의존하여
                조화를 이루는 빈티지 함과 동시에 모던 함을 지닌
                클래식한 트위스트를 선보입니다.`,
                intromobile: `마스콥(MASSCOB) 은
                마르가 마사네트(Marga Massanet)와
                쟈코보 코비안(Jacobo Cobián)이 2003년
                스페인의 라 꼬류냐에서 두 사람의 이름에서
                착안하여 설립한 브랜드 입니다. 

                여성성과 남성성을 모두 가진 듀얼 퍼스널리티를
                표방하는 이 브랜드는 단순히 트렌드 만을 
                쫓지 않고, 두 설립자이자 디자이너의 직관에 
                의존하여 조화를 이루는 빈티지 함과
                동시에 모던 함을 지닌 클래식한
                트위스트를 선보입니다.`,
                hashtag: '#빈티지컨템포러리 #클래식트위스트 #스페인',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/masscob',
            },
            {
                brandname: 'YUZEFI',
                brandnamekr: '유제피',
                intro: `실험적인 디자인을 기반으로 한 런던 베이스의 패션 브랜드, 유제피 (YUZEFI)는
                창조성과 새로운 것에 대한 독특한 접근으로 가방의 구조적인 디테일과 
                실루엣에 한 걸음 더 다가가는 디자인을 선보인다. 
                
                나자 유제피 (Naza Yousefi)의 디렉션 아래 창조 되는 컬렉션들은 공개 이후 
                세계의 젊은 패션 마니아들의 지지를 받고 있다.

                미니멀한 디자인에 트위스트를 가미한 구조적이고 독창적이지만 
                심플한 핸드백 라인으로 주목을 받으며, 최근 여성복 라인으로도 
                컬렉션을 확장하며 주목 받고 있다. 
                `,
                intromobile: `실험적인 디자인을 기반으로 한 런던 베이스의 
                패션 브랜드, 유제피 (YUZEFI)는
                창조성과 새로운 것에 대한 독특한 접근으로 
                가방의 구조적인 디테일과 실루엣에 
                한 걸음 더 다가가는 디자인을 선보인다. 
                
                나자 유제피 (Naza Yousefi)의 디렉션 아래 
                창조 되는 컬렉션들은 공개 이후 
                세계의 젊은 패션 마니아들의 지지를 받고 있다.

                미니멀한 디자인에 트위스트를 가미한 
                구조적이고 독창적이지만 
                심플한 핸드백 라인으로 주목을 받으며, 
                최근 여성복 라인으로도 컬렉션을 확장하며 
                주목 받고 있다.
                `,
                hashtag: '#런던패션 #구조적핸드백 #포츈쿠키백 #트렌디디자이너백',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/cms/magazine/view/2063',
            },
            {
                brandname: 'NORSE PROJECTS',
                brandnamekr: '노스프로젝트',
                intro: `노스 프로젝트(NORSE PROJECTS)는 덴마크 코펜하겐에서 탄생한 브랜드 입니다.
                토비아 슬로스(Tobia Sloth)의 크리에이티브 디렉팅 아래
                스트릿, 클래식 워크웨어에 하이엔드 패션의 요소가 가미된 라인을 선보입니다.
                
                2004년 아트 갤러리와 스토어의 형태로 첫 오픈 이래,
                2009년 노스 프로젝트 남성 라인을 선보이며 주목 받으며 스칸디나비안 패션의 
                선구자적 입지를 다지고 있습니다.`,
                intromobile: `노스 프로젝트(NORSE PROJECTS)는 
                덴마크 코펜하겐에서 탄생한 브랜드 입니다.

                토비아 슬로스(Tobia Sloth)의
                크리에이티브 디렉팅 아래 스트릿,
                 클래식 워크웨어에 하이엔드 패션의 요소가
                가미된 라인을 선보입니다. 
                
                2004년 아트 갤러리와 스토어의
                형태로 첫 오픈 이래, 2009년 노스프로젝트남성
                라인을선보이며 주목 받으며 스칸디나비안
                패션의 선구자적 입지를 다지고 있습니다.`,
                hashtag: '#모던캐쥬얼 #워크웨어 #북유럽',
                logoformat: 'png',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/cms/magazine/view/2063',
            },
            {
                brandname: 'CFCL',
                brandnamekr: '씨에프씨엘',
                intro: `2020년 이세이 미야케(Issey Miyake) 출신 디자이너 유스케 타카하시(Yusuke Takahashi) 가
                설립한 ESG 브랜드이며, 아방가르드한 실루엣과 시그니처 플리팅 디테일이
                돋보이는 컬렉션을 전개한다.
                
                CFCL은 현대인의 삶을 위한 옷이라는 의미를 담은 "Clothing for Contemporary Life"의 약자로,
                혁신적인 제작 기술과 지속가능성을 실천한다.`,
                intromobile: `2020년 이세이 미야케(Issey Miyake) 출신 
                디자이너 유스케 타카하시(Yusuke Takahashi) 가
                설립한 ESG 브랜드이며, 아방가르드한 실루엣과 시그니처 플리팅 디테일이돋보이는
                컬렉션을 전개한다.
                
                CFCL은 현대인의 삶을 위한 옷이라는 의미를 담은 "Clothing for Contemporary Life"의 약자로,
                혁신적인 제작 기술과 지속가능성을 실천한다.`,
                hashtag: '#ESG브랜드 #플리팅 #아방가르드',
                logoformat: 'png',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/cms/magazine/view/1791',
            },
            {
                brandname: 'SUNNEI',
                brandnamekr: '써네이',
                intro: `이탈리아어로 Sunny를 뜻하는 써네이(SUNNEI)는,
                이름처럼 밝고 경쾌한 브랜드이다.
                
                2015년 밀라노에서 로리스 메시나(Loris Messina)와 시몬느 리조(Simone Rizzo)가
                설립한 이 브랜드는, 틀에 얽메이지 않은 자유분방한 스타일을 제안하며,
                22FW에는 밀라노 골목을 달리는 런웨이를 선보이는 등,
                기존의 답습 하던 패션의 관행을 따르지 않으며,
                자신들의 스타일을 구축해 나가며 젊은 층의 지지를 받고 있다.`,
                intromobile: `이탈리아어로 Sunny를 뜻하는 써네이(SUNNEI)는,
                이름처럼 밝고 경쾌한 브랜드이다.
                
                2015년 밀라노에서 로리스 메시나
                (Loris Messina)와 시몬느 리조(Simone Rizzo)가
                설립한 이 브랜드는, 틀에 얽메이지 않은
                자유분방한 스타일을 제안하며,
                22FW에는 밀라노 골목을 달리는 런웨이를
                선보이는 등, 기존의 답습 하던 패션의
                관행을 따르지 않으며, 자신들의 스타일을
                구축해 나가며 젊은 층의 지지를 받고 있다.`,
                hashtag: '#스트릿 #sprezzatura #볼드한컬러',
                logoformat: 'png',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/sunnei',
            },
            {
                brandname: 'WOERA',
                brandnamekr: '우에라',
                intro: `그리스 아테네에서 디자이너 나탈리아 지오갈라(Natalia Georgala)가
                설립한 우에라는, 본래 남성을 위해 만들어진 셔츠라는 가먼트를 사용하여
                여성의 우아함을 강조하는 옷을 디자인 합니다.
                
                Effortless Elegance를 표방하며, 다양한 무드에서 우아하지만 때로는 포멀하게,
                때로는 캐쥬얼하게 스타일링 할 수 있는 피스들을 제안합니다.`,
                intromobile: `그리스 아테네에서 디자이너 나탈리아 
                지오갈라(Natalia Georgala)가 설립한 우에라는, 
                본래 남성을 위해 만들어진 셔츠라는  가먼트를 
                사용하여 여성의 우아함을 강조하는 
                옷을 디자인 합니다.
                
                Effortless Elegance를 표방하며, 다양한 
                무드에서  우아하지만 때로는 포멀하게, 때로는 
                캐쥬얼하게 스타일링 할 수 있는 
                피스들을 제안합니다.`,
                hashtag: '',
                logoformat: 'png',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/woera',
            },
            {
                brandname: 'NANUSHKA',
                brandnamekr: '나누쉬카',
                intro: `부다페스트 기반 ESG 브랜드 나누쉬카(NANUSHKA)는
                보헤미안 패턴과 텍스처를 미니멀한 실루엣에 입혀, 절제미와 자유분방함의 균형을 맞춘다.
                
                대표적인 ESG 브랜드답게 공급사슬을 투명하게 공유하며,
                상품의 라이프사이클을 최대한 늘리기 위해 리페어 서비스, 렌탈 서비스, 업사이클링을
                실천하는 '착한 브랜드'이다.`,
                intromobile: `부다페스트 기반 ESG 브랜
                나누쉬카(NANUSHKA)는 보헤미안 패턴과
                텍스처를 미니멀한 실루엣에 입혀, 절제미와
                자유분방함의 균형을 맞춘다.
                
                대표적인 ESG 브랜드답게 공급사슬을
                투명하게 공유하며,
                상품의 라이프사이클을 최대한 늘리기 위해
                리페어 서비스, 렌탈 서비스, 업사이클링을
                실천하는 '착한 브랜드'이다.`,
                hashtag: '#보헤미안 #지속가능성 #미니멀',
                logoformat: 'png',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/cms/magazine/view/1791',
            },
            {
                brandname: 'BY FAR',
                brandnamekr: '바이 파 ',
                intro: `쌍둥이 자매와 그들의 절친이 런칭한 불가리아 브랜드 바이 파 (BY FAR)는
                모던하고 클래식한 실루엣과 튀는 컬러웨이가 돋보인다.
                
                켄달 제너, 블랙핑크 제니를 비롯한 국내외 셀럽들의 사랑을 받으며,
                Affordable Luxury의 대표적인 브랜드로 자리매김하였다.`,
                intromobile: `쌍둥이 자매와 그들의 절친이 런칭한 불가리아 브랜드 바이 파 (BY FAR)는
                모던하고 클래식한 실루엣과 튀는 컬러웨이가 돋보인다.
                
                켄달 제너, 블랙핑크 제니를 비롯한 국내외 셀럽들의 사랑을 받으며,
                Affordable Luxury의 대표적인 브랜드로 자리매김하였다.`,
                hashtag: '#컬러백 #모던클래식 #미니백',
                logoformat: 'png',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/byfar',
            },
        ],
    },
    {
        roomname: 'Player',
        hasee: -1,
        roomlogo: 'roomlogo-player.svg',
        introtext: '모두의 플레이가 시작된다',
        introtext2: '기능성을 넘어, 당신의 가능성을 열다 진정 스포츠를 사랑하는 플레이의 시작',
        tlblip_arr: [],
        contents: [
            {
                brandname: 'ANDAR ',
                brandnamekr: '안다르',
                intro: `K애슬레저 리딩 브랜드 안다르는 운동과 일상의 경계를 넘나들며
                언제어디서나 조화롭고 편안할 수 있는 데일리 애슬레저 문화를 지향합니다.
                
                안다르를 입는 순간 느껴지는 편안함과 자유로움이
                모두의 일상 속에 함께하길 꿈꿉니다.`,
                intromobile: `K애슬레저 리딩 브랜드 안다르는
                운동과 일상의 경계를 넘나들며
                언제어디서나 조화롭고 편안할 수 있는
                데일리 애슬레저 문화를 지향합니다.
                
                안다르를 입는 순간 느껴지는 편안함과
                자유로움이 모두의 일상 속에 함께하길 꿈꿉니다.`,
                hashtag: '#애슬레저 #레깅스 #요가복 #필라테스',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/andar',
            },
            {
                brandname: 'ARENA ',
                brandnamekr: '아레나',
                intro: `아레나(ARENA)는 40년 동안 심도 깊은 연구와 테크놀로지 노하우, 품질에 대한 
                굳은 의지로 전 세계 103개국에 진출해 있습니다. 
                
                선수들과 스포츠를 사랑하는 일반인 모두를 위한 
                진정한 글로벌 스포츠 브랜드입니다.`,
                intromobile: `아레나(ARENA)는 40년 동안 심도 깊은 연구와 
                테크놀로지 노하우, 품질에 대한 
                굳은 의지로 전 세계 103개국에 진출해 있습니다. 
                
                선수들과 스포츠를 사랑하는 일반인 모두를 위한 
                진정한 글로벌 스포츠 브랜드입니다.`,
                hashtag: '#아레나수영복 #수영 #아레나스윔 #실내수영',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/arena',
            },
            {
                brandname: 'NEW BALANCE',
                brandnamekr: '뉴발란스',
                intro: `뉴발란스(NEW BALANCE)는 발에 장애가 있거나 경찰, 소방관, 우체부 등
                하루 종일 서서 일하는 사람들을 위한
                아치 서포트(Arch Support : 지지대가 있는 신발 깔창)를 만들며
                1906년에 미국 메사추세츠주 보스턴에서 론칭했습니다.
                
                닭의 세 개의 발톱이 만드는 균형(balance)에서 영감을 얻은 아치 서포트와 신발은
                지금도 변치 않고 100년이 지난 지금도 여전히 불균형한 발에 새로운 균형을 창조하는
                다양한 디자인의 스니커즈와 스포츠&패션 아이템을 만들고 있습니다. `,
                intromobile: `뉴발란스(NEW BALANCE)는 발에 장애가 있거나 경찰, 소방관, 우체부 등 하루 종일
                서서 일하는 사람들을 위한 아치 서포트
                (Arch Support : 지지대가 있는 신발 깔창)를
                만들며 1906년에 미국 메사추세츠주 보스턴에서 론칭했습니다.
                
                닭의 세 개의 발톱이 만드는 균형(balance)에서
                영감을 얻은 아치 서포트와 신발은
                지금도 변치 않고 100년이 지난 지금도 여전히
                불균형한 발에 새로운 균형을 창조하는
                다양한 디자인의 스니커즈와
                스포츠&패션 아이템을 만들고 있습니다. `,
                hashtag: '#뉴발란스 #뉴발란스러닝 #NBRC',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/newbalance',
            },
            {
                brandname: 'SNOWPEAK',
                brandnamekr: '스노우피크',
                intro: `스노우피크 아웃도어 라이프 밸류 어패럴&캠프는
                사람과 자연이 어우러지는 생활의 가치를 제안하는 아웃도어 라이프 스타일 브랜드입니다.
                
                사용자의 입장에서 제품을 만들고 서비스를 제안하며, 오랜 시간 사용할 수 있는
                가치 높은 아이템을 선보이는 브랜드입니다.`,
                intromobile: `스노우피크 아웃도어 라이프 밸류 어패럴&캠프는
                사람과 자연이 어우러지는 생활의 가치를
                제안하는 아웃도어 라이프 스타일 브랜드입니다.
                
                사용자의 입장에서 제품을 만들고 서비스를
                제안하며, 오랜 시간 사용할 수 있는
                가치 높은 아이템을 선보이는 브랜드입니다.`,
                hashtag: '#스노우피크 #SNOWPEAK #스노우피크캠핑',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/snowpeak',
            },
            {
                brandname: 'THE NORTH FACE',
                brandnamekr: '노스페이스',
                intro: `노스페이스(THE NORTHFACE)는 탐험과 도전을 통해
                세상을 변화시켜 나가고자 합니다. 
                
                브랜드 모토인 'NEVER STOP EXPLORATION(멈추지 않는 탐험)'은
                브랜드가 추구하는 활동이자 마인드셋이며
                다양한 아웃도어 활동으로부터 헤리티지와 메트로폴리탄 라이프스타일의
                관련성을 증가시키는 브랜드의 진정성입니다.`,
                intromobile: `노스페이스(THE NORTHFACE)는
                탐험과 도전을 통해
                세상을 변화시켜 나가고자 합니다. 
                
                브랜드 모토인 'NEVER STOP EXPLORATION
                (멈추지 않는 탐험)'은
                브랜드가 추구하는 활동이자 마인드셋이며
                다양한 아웃도어 활동으로부터 헤리티지와
                메트로폴리탄 라이프스타일의
                관련성을 증가시키는 브랜드의 진정성입니다.`,
                hashtag: '#화이트라벨 #캠핑 #아웃도어 #thenorthface #바람막이자켓',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/thenorthface',
            },
            {
                brandname: 'ASICS',
                brandnamekr: '아식스',
                intro: `ASICS는 1949년 황폐한 패전 직후의 고베에서
                "스포츠를 통해서 아이들의 건전한 육성에 보템이 되겠다."라는 바람으로
                오니츠카 키하치에 의해 설립되었습니다.
                
                아식스는 오니츠카 키하치로의 창업정신을 잇기 위해서 기원 2세기경 로마의 작가 유베날리스가 남긴
                "건강한 정신은 건강한 육체에서(Anima Sana In Corpore Sano)"의 알파벳 앞글자를 따 사명을 지었으며,
                전 세계적으로 다양한 컬렉션으로 사랑받고 있는 글로벌 브랜드입니다. `,
                intromobile: `ASICS는 1949년 황폐한 패전 직후의 고베에서
                "스포츠를 통해서 아이들의 건전한 육성에
                보템이 되겠다."라는 바람으로
                오니츠카 키하치에 의해 설립되었습니다.
                
                아식스는 오니츠카 키하치로의 창업정신을
                잇기 위해서 기원 2세기경 로마의 작가
                유베날리스가 남긴
                "건강한 정신은 건강한 육체에서(Anima Sana In Corpore Sano)"의 알파벳 앞글자를 따
                사명을 지었으며, 전 세계적으로 다양한
                컬렉션으로 사랑받고 있는 글로벌 브랜드입니다. `,
                hashtag: '#아식스 #아식스스포츠스타일 #Sound mind #Sound body',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/asics',
            },
            {
                brandname: 'UNDER ARMOUR',
                brandnamekr: '언더아머',
                intro: `언더아머(Under Armour, Inc.)는 1996년 볼티모어, 메릴랜드에서
                탄생한 글로벌 스포츠 브랜드입니다.
                
                운동복 안에 입는 갑옷이라는 의미를 담아 이름 지었고, 티셔츠 한장으로
                운동선수 대부분의 운동복 착용 방법을 바꿔 놓았습니다.
                
                브랜드 미션인 “Under Armour Makes You Better” 슬로건 아래 모든 사람들이
                최상의 퍼포먼스를 경험할 수 있도록 기능성 스포츠 제품을 제공하며
                세계적인 운동 선수들은 물론 대중적으로도 사랑받는 브랜드로 자리 잡았습니다.`,
                intromobile: `언더아머(Under Armour, Inc.)는 1996년
                볼티모어, 메릴랜드에서 탄생한 글로벌
                스포츠 브랜드입니다.
                
                운동복 안에 입는 갑옷이라는 의미를 담아
                이름 지었고, 티셔츠 한장으로
                운동선수 대부분의 운동복 착용 방법을
                바꿔 놓았습니다.
                
                브랜드 미션인
                “Under Armour Makes You Better”
                슬로건 아래 모든 사람들이
                최상의 퍼포먼스를 경험할 수 있도록 기능성
                스포츠 제품을 제공하며
                세계적인 운동 선수들은 물론 대중적으로도
                사랑받는 브랜드로 자리 잡았습니다.`,
                hashtag: '#언더아머 #UNDERARMOUR #나를돌파 #오직돌파',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/underarmour',
            },
            {
                brandname: 'PUMA',
                brandnamekr: '푸마',
                intro: `독일에서 탄생한 세계적인 스포츠 브랜드 푸마(PUMA).
                현재 스포츠 퍼포먼스에서 영감을 받은 다양한 라이프스타일 제품을
                선보이고 있으며, 뛰어난 퀄리티는 물론 다양한 디자이너와의 컬래버레이션으로
                많은 사랑을 받고 있습니다.`,
                intromobile: `독일에서 탄생한 세계적인 스포츠 브랜드 
                푸마(PUMA).
                현재 스포츠 퍼포먼스에서 영감을 받은 다양한 
                라이프스타일 제품을 선보이고 있으며, 
                뛰어난 퀄리티는 물론 다양한 디자이너와의
                컬래버레이션으로많은 사랑을 받고 있습니다.`,
                hashtag: '#푸마 #푸마퍼포먼스 #푸마런닝화 #푸마아미트레이너',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/puma',
            },
        ],
    },
    {
        roomname: 'Beauty',
        hasee: -1,
        roomlogo: 'roomlogo-beauty.svg',
        introtext: '진정한 아름다움을 입다 뷰티풀 무신사',
        introtext2: '나만의 아름다움이 가장 트렌디한 아름다움 개성이 돋보이는 뷰티를 찾는 여정',
        tlblip_arr: [],
        contents: [
            {
                brandname: 'HERA ',
                brandnamekr: '헤라',
                intro: `헤라(HERA)는 한국 여성의 트렌디하고 세련된 스타일을 위해
                메이크업, 스킨케어, 퍼퓸 등 토탈 뷰티 케어를 제공합니다.
                
                헤라는 ‘Exceptional Beauty from Seoul’이라는 주제로 한국 여성의 아름다움을 대표하고 있습니다.
                헤라는 이제 아시아의 트렌드를 창조하고 전파하는 뷰티 메신저로
                한국 여성의 특별한 아름다움과 가치를 세계에 전합니다. `,
                intromobile: `헤라(HERA)는 한국 여성의 트렌디하고
                세련된 스타일을 위해 메이크업, 스킨케어,
                퍼퓸 등 토탈 뷰티 케어를 제공합니다.
                
                헤라는 ‘Exceptional Beauty from Seoul’이라는
                주제로 한국 여성의 아름다움을
                대표하고 있습니다.
                
                헤라는 이제 아시아의 트렌드를 창조하고
                전파하는 뷰티 메신저로 한국 여성의 특별한
                아름다움과 가치를 세계에 전합니다. `,
                hashtag: '#블랙쿠션 #쿠션 #센슈얼파우더매트',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/hera',
            },
            {
                brandname: 'BELIF ',
                brandnamekr: '빌리프',
                intro: `빌리프(belif)는 2010년, 영국 허브 전문가 Napiers의 
                160여년의 전통 조제기법과 철학을 계승하여 탄생했습니다. 
                
                효능이 탁월한 허브에 오랜 전통과 깊이 있는 지식을 더함으로써, 뛰어난 퀄리티(True quality)와
                높은 가치(True value)를 처방하는 트루 허브 코스메틱 브랜드입니다.
                
                빌리프는 뛰어난 성분과 효능을 안전하고 정직하게 피부 위에 구현하는 진실된 브랜드로서,
                고객에게 신뢰와 믿음의 일관된 약속을 전달하고 있습니다.`,
                intromobile: `빌리프(belif)는 2010년, 영국 허브 전문가 
                Napiers의  160여년의 전통 조제기법과 철학을 
                계승하여 탄생했습니다. 
                
                효능이 탁월한 허브에 오랜 전통과 
                깊이 있는 지식을 더함으로써, 뛰어난 퀄리티
                (True quality)와 높은 가치(True value)를 
                처방하는 트루 허브 코스메틱 브랜드입니다.
                
                빌리프는 뛰어난 성분과 효능을 안전하고 
                정직하게 피부 위에 구현하는 진실된 브랜드로서,
                고객에게 신뢰와 믿음의 일관된 약속을 
                전달하고 있습니다.`,
                hashtag: '#빌리프 #belif #빌리프수분크림 #모밤 #아밤 #폭탄크림 #맨올로지',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/belif',
            },
            {
                brandname: 'JUNGSAEMMOOL',
                brandnamekr: '정샘물',
                intro: `한국을 대표하는 프로페셔널 메이크업 아티스트 브랜드 정샘물(JUNGSAEMMOOL)은
                메이크업 전문가의 손길이 닿은 것처럼 “본연의 아름다움”을 이끌어내도록 기획됩니다.
                
                메이크업 아티스트 정샘물의 수년간의 경험과 순수 미술 기법에서
                직접 고안한 정샘물만의 노하우를 토대로 설계되어,
                트렌드만을 쫓기보다는 자신만의 아름다움을 발견할 수 있도록 도와드립니다. `,
                intromobile: `한국을 대표하는 프로페셔널 메이크업 아티스트 브랜드 정샘물(JUNGSAEMMOOL)은
                메이크업 전문가의 손길이 닿은 것처럼 
                “본연의 아름다움”을 이끌어내도록 기획됩니다.
                
                메이크업 아티스트 정샘물의 수년간의 경험과 
                순수 미술 기법에서 직접 고안한 정샘물만의 
                노하우를 토대로 설계되어,
                트렌드만을 쫓기보다는 자신만의 아름다움을 
                발견할 수 있도록 도와드립니다. `,
                hashtag: '#정샘물쿠션 #정샘물에센셜쿠션 #물크림 #정샘물',
                logoformat: 'png',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/jsm',
            },
            {
                brandname: 'KAHI',
                brandnamekr: '가히',
                intro: `아름다움을 향한 여성들의 로망을 실현시키기 위해 탄생한 스킨케어 브랜드 가히(KAHI)는
                누구나 쉽게 아름다워질 수 있는 세상을 만들겠다는 철학으로제품을 만듭니다. 
                
                모든 사람이 쉽게 익힐 수 있도록 고안된 '한글'의 자음, 모음의 시작과 끝 음운으로 
                만들어진 브랜드 이름처럼, ‘가히 멀티밤’을 비롯한 아이코닉한 스테디셀러들은 
                언제 어디서나 좋은 성분을 쉽게 바르는 습관을 만들고자 기획합니다. `,
                intromobile: `아름다움을 향한 여성들의 로망을 실현시키기 
                위해 탄생한 스킨케어 브랜드 가히(KAHI)는
                누구나 쉽게 아름다워질 수 있는 세상을 
                만들겠다는 철학으로제품을 만듭니다. 
                
                모든 사람이 쉽게 익힐 수 있도록 고안된 
                '한글'의 자음, 모음의 시작과 끝 음운으로 
                만들어진 브랜드 이름처럼, ‘가히 멀티밤’을 
                비롯한 아이코닉한 스테디셀러들은 
                언제 어디서나 좋은 성분을 쉽게 바르는 습관을 
                만들고자 기획합니다. `,
                hashtag: '#매일설레는습관 #바르는뷰티 #가히 #가히멀티밤 #멀티밤',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/kahi',
            },
            {
                brandname: '3CE',
                brandnamekr: '3CE',
                intro: `쓰리씨이(3CE)는 3가지 매력적인 시선으로 패셔너블한 여성을 
                빛나게 만들어 주는 메이크업 브랜드입니다. 
                
                3CE와 함께라면 누구나 모던한 컬러의 다양한 스펙트럼으로, 
                크리에이티브하고 차별화된 느낌의 메이크오버를 경험할 수 있습니다.`,
                intromobile: `쓰리씨이(3CE)는 3가지 매력적인 시선으로 
                패셔너블한 여성을 빛나게 만들어 주는 
                메이크업 브랜드입니다. 
                
                3CE와 함께라면 누구나 모던한 컬러의 
                다양한 스펙트럼으로, 
                크리에이티브하고 차별화된 느낌의 
                메이크오버를 경험할 수 있습니다.`,
                hashtag: '#3CE  #3CE틴트 #3CE아이섀도우 #스타일난다',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/3ce',
            },
        ],
    },
    {
        roomname: 'Kids',
        hasee: -1,
        roomlogo: 'roomlogo-kids.svg',
        brandnamekr: '엠엘비키즈',
        introtext: '감각적 패밀리룩의 완성',
        introtext2: '아이의 취향이 자랄수록, 가족의 패션도 함께 자란다. 무신사 키즈의 패밀리룩',
        tlblip_arr: [],
        contents: [
            {
                brandname: 'MLB KIDS ',
                brandnamekr: '엠엘비키즈',
                intro: `엠엘비 키즈(MLB KIDS)는 스트릿한 감성과 엠엘비의 헤리티지를 믹스하여
                스타일리시한 키즈 룩을 선보이는 브랜드입니다.`,
                intromobile: `엠엘비 키즈(MLB KIDS)는 스트릿한 감성과
                엠엘비의 헤리티지를 믹스하여 스타일리시한 
               키즈 룩을 선보이는 브랜드입니다.`,
                hashtag: '#MLB키즈반팔세트 #MLB키즈상하복 #MLB키즈반팔티 #MLB키즈냉감 #MLB키즈기능',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/mlbkids',
            },
            {
                brandname: 'NATIONAL GEOGRAPHIC KIDS ',
                brandnamekr: '내셔널지오그래픽 키즈',
                intro: `내셔널지오그래픽 키즈(NATIONAL GEOGRAPHIC KIDS)는
                적극적으로 자신을 표현하며 가치 소비를 추구하는 여러분을 위해 
                의류, 캐리어, 백팩, 캠핑 등 700여 가지가 넘는 다양한 제품을 제안하는 
                내셔널지오그래픽(NATIONAL GEOGRAPHIC)의 키즈 라인입니다.`,
                intromobile: `내셔널지오그래픽 키즈
                (NATIONAL GEOGRAPHIC KIDS)는
                적극적으로 자신을 표현하며 가치 소비를 
                추구하는 여러분을 위해 
                의류, 캐리어, 백팩, 캠핑 등 700여 가지가 넘는 
                다양한 제품을 제안하는 
                내셔널지오그래픽(NATIONAL GEOGRAPHIC)의 키즈 라인입니다.`,
                hashtag: '#반팔티셔츠 #반바지 #신발 #가방',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/nationalgeographickids',
            },
            {
                brandname: 'KANGOL KIDS',
                brandnamekr: '캉골키즈',
                intro: `캉골키즈(KANGOL KIDS)는 복잡하지 않은 것보다 본질적이고 
                기본적인 것에 충실하며 유행과 평범함 사이에 존재하는, 
                스트릿과 클래식한 감성이 공존하는 브랜드입니다. `,
                intromobile: `캉골키즈(KANGOL KIDS)는 복잡하지 않은 것보다 본질적이고 기본적인 것에 충실하며 유행과 
                평범함 사이에 존재하는, 스트릿과 클래식한 
                감성이 공존하는 브랜드입니다. `,
                hashtag: '#키즈선물 #키즈등원룩 #키즈티셔츠 #신학기코디',
                logoformat: 'png',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/kangolkids',
            },

            {
                brandname: 'HIRO',
                brandnamekr: '히로',
                intro: `히로(HIRO)는 스케이트보드, 힙스터, 스트릿을 주제로 
                매 시즌 다양한 아이템을 선보이는 키즈 브랜드입니다.`,
                intromobile: `히로(HIRO)는 스케이트보드, 힙스터, 스트릿을 
                주제로 매 시즌 다양한 아이템을 선보이는 
                키즈 브랜드입니다.`,
                hashtag: '#힙스터 #스트릿키즈 #체커보드 #스케이트보드',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/hiro',
            },

            {
                brandname: 'MARDI MERCREDI LESPETITS',
                brandnamekr: '마르디 메크르디 레쁘띠',
                intro: `마르디 메크르디 레쁘띠(MARDI MERCREDI LESPETITS)는 과감하지만
                이지하고 위트 있는 데일리 룩을 제안하는 컨템포러리 디자이너 브랜드입니다.
                다양한 컬러와 소재의 변주로 차별화를 부여합니다. `,
                intromobile: `마르디 메크르디 레쁘띠
                (MARDI MERCREDI LESPETITS)는 과감하지만
                이지하고 위트 있는 데일리 룩을 제안하는
                 컨템포러리 디자이너 브랜드입니다.
                다양한 컬러와 소재의 변주로 차별화를 
                부여합니다. `,
                hashtag: '#signature #edgy #allday',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/mardimercredilespetits',
            },
        ],
    },
    {
        roomname: 'Golf',
        hasee: -1,
        roomlogo: 'roomlogo-golf.svg',
        introtext: '일상과 필드, 런웨이가 되다',
        introtext2: '홀인원보다 빠른 트렌드, 퍼팅보다 섬세한 감도. 필드와 일상 모두 스타일리시하게',
        tlblip_arr: [],
        contents: [
            {
                brandname: 'CLOVE ',
                brandnamekr: '클로브',
                intro: `클로브(CLOVE)는 클래식 감성의 라이프 웨어 브랜드입니다. 
                심플&클래식 스타일에서 모티브를 얻은 디자인에 스포티 무드와 기능성 소재를 더해 
                클로브만의 아이덴티티를 드러냅니다. 
                
                골프, 테니스, 여행 뿐만 아니라 언제, 어디서든 쉽게 입고 편하게 활동할 수 있는
                세련된 스타일의 웨어러블 아이템을 만듭니다. `,
                intromobile: `클로브(CLOVE)는 클래식 감성의 라이프 웨어 
                브랜드입니다. 
                심플&클래식 스타일에서 모티브를 얻은 디자인에 스포티 무드와 기능성 소재를 더해 
                클로브만의 아이덴티티를 드러냅니다. 
                
                골프, 테니스, 여행 뿐만 아니라 언제, 어디서든 
                쉽게 입고 편하게 활동할 수 있는
                세련된 스타일의 웨어러블 아이템을 만듭니다. `,
                hashtag: '#어반 골프 라이프스타일 #테니스& 골프웨어 #원마일웨어 #웨어러블 스포츠웨어',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/clove',
            },
            {
                brandname: 'MARDI MERCREDI ACTIF ',
                brandnamekr: '마르디 메크르디 악티프',
                intro: `마르디 메크르디 악티프(MARDI MERCREDI ACTIF)는 마르디 메크르디(MARDI MERCREDI)의 
                위트 있는 스포츠 라인입니다. 
                시그니처 플라워 프린트를 담은 다양한 애슬레저 웨어를 선보입니다.`,
                intromobile: `마르디 메크르디 악티프
                (MARDI MERCREDI ACTIF)는 
                마르디 메크르디(MARDI MERCREDI)의 
                위트 있는 스포츠 라인입니다. 
                시그니처 플라워 프린트를 담은 다양한 
                애슬레저 웨어를 선보입니다.`,
                hashtag: '#마르디 메크르디 스포츠라인 #프렌치 무드 캐주얼 골프웨어 #시그니처 플라워 패턴 #팝 컬러 포인트',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/mardimercrediactif',
            },
            {
                brandname: 'MALBON GOLF',
                brandnamekr: '말본 골프',
                intro: `말본 골프(MALBON GOLF)는 패션 디자이너 스테판 말본과 에리카 말본 부부가 론칭한
                스트릿 감성의 라이프스타일 골프 웨어 브랜드입니다.
                
                패션 스피릿을 기반으로 골프의 DNA를 담은 말본 골프는 브랜드 고유의 유니크한 색감과 실루엣, 로고 플레이로
                영 골퍼를 위한 세련된 필드 룩 스타일과 퍼포먼스 리더십을 제안합니다. `,
                intromobile: `말본 골프(MALBON GOLF)는 패션 디자이너 
                스테판 말본과 에리카 말본 부부가 론칭한
                스트릿 감성의 라이프스타일 골프 웨어 
                브랜드입니다.
                
                패션 스피릿을 기반으로 골프의 DNA를 담은 
                말본 골프는 브랜드 고유의 유니크한 색감과 
                실루엣, 로고 플레이로
                영 골퍼를 위한 세련된 필드 룩 스타일과 
                퍼포먼스 리더십을 제안합니다. `,
                hashtag: '#스트릿 캐주얼 골프웨어 #캘리포니아 무드 골프웨어 #로고 플레이 #GOLF IS LIFE',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/malbongolf',
            },
            {
                brandname: 'CHALLENGER',
                brandnamekr: '챌린저',
                intro: `챌린저(CHALLENGER)는 유럽의 자유롭고 아티스틱한 감성이 녹아 있는
                프리미엄 유틸리티 골프 웨어 브랜드입니다.
                
                기존 골프 웨어에서 표현할 수 없던 개성과 고급스럽고 독특한 소재의 디테일을 선보이며
                골프 웨어 시장에 새로운 트렌드를 제시합니다.`,
                intromobile: `챌린저(CHALLENGER)는 유럽의 자유롭고 
                아티스틱한 감성이 녹아 있는
                프리미엄 유틸리티 골프 웨어 브랜드입니다.
                
                기존 골프 웨어에서 표현할 수 없던 개성과
                 고급스럽고 독특한 소재의 디테일을 선보이며
                골프 웨어 시장에 새로운 트렌드를 제시합니다.`,
                hashtag: '#유틸리티 골프웨어 #테크 골프웨어 #퓨처리스틱 스타일 #사이버 펑크 ',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/challenger',
            },
            {
                brandname: 'JAMIE WEST',
                brandnamekr: '제이미웨스트',
                intro: `제이미웨스트(JAMIE WEST)는 평범함을 거부하는 사람들을 위한 골프 브랜드입니다.
                조잡하지 않은 정교한 퀄리티, 부드러운 것보다는 거친 것, 기본에 충실하면서도 확고한 어떤 것,
                필드와 일상 어디에서도 당신을 그대로 보여주는 것.
                제이미웨스트는 이러한 것들을 추구합니다. `,
                intromobile: `제이미웨스트(JAMIE WEST)는
                평범함을 거부하는 사람들을 위한 
                골프 브랜드입니다.
                
                조잡하지 않은 정교한 퀄리티, 부드러운 것보다는 거친 것, 기본에 충실하면서도
                확고한 어떤 것, 필드와 일상 어디에서도 
                당신을 그대로 보여주는 것.
                제이미웨스트는 이러한 것들을 추구합니다. `,
                hashtag: '#스트릿 골프웨어 #언더그라운드 펑크 #모노톤 컬러 #남성 골프웨어',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/jamiewest',
            },
            {
                brandname: 'DESCENTE GOLF',
                brandnamekr: '데상트 골프',
                intro: `데상트 골프(DESCENTE GOLF)는 스포츠 분야에서 
                높은 경쟁력을 지닌 데상트의 퀄리티와 테크놀로지를 바탕으로 
                "DESIGN THAT MOVES"라는 슬로건을 공유하는 골프 브랜드입니다. 
                
                데상트 골프는 'Innovative, Professional, Technology'를 핵심 키워드로 혁신적인 디자인과 
                최고의 기능성을 통해 골퍼의 퍼포먼스를 극대화하여 골프의 지평을 확장합니다. `,
                intromobile: `데상트 골프(DESCENTE GOLF)는 스포츠 
                분야에서 높은 경쟁력을 지닌 데상트의 퀄리티와 테크놀로지를 바탕으로 
                "DESIGN THAT MOVES"라는 슬로건을 공유하는 골프 브랜드입니다. 
                
                데상트 골프는 'Innovative, Professional, Technology'를 핵심 키워드로 혁신적인 디자인과 
                최고의 기능성을 통해 골퍼의 퍼포먼스를 극대화하여 골프의 지평을 확장합니다. `,
                hashtag: '#퍼포먼스 #테크웨어 #기능성',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/descentegolf',
            },
            {
                brandname: 'MARK&LONA',
                brandnamekr: '마크앤로나',
                intro: `마크앤로나(MARK&LONA)는 럭셔리 골프를 콘셉트로 프레피 펑크, 마린 등
                색다른 차세대 스포츠 웨어를 제안하는 브랜드입니다.
                
                유명 부티크들의 뜨거운 성원에 힘입어 다양한 골프 매체에 보도되어 이름을 알렸습니다.`,
                intromobile: `마크앤로나(MARK&LONA)는 럭셔리 골프를 
                콘셉트로 프레피 펑크, 마린 등
                색다른 차세대 스포츠 웨어를 제안하는 
                브랜드입니다.
                
                유명 부티크들의 뜨거운 성원에 힘입어 다양한 
                골프 매체에 보도되어 이름을 알렸습니다.`,
                hashtag: '#럭셔리 골프웨어 #카모플라주 패턴 #프레피 스타일 #펑크 골프웨어',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/markandlona',
            },
            {
                brandname: 'LESONNET',
                brandnamekr: '르쏘넷',
                intro: `르쏘넷(LESONNET)은 그린 위에서 즐기는 스포티 라이프를 추구하는 브랜드입니다. 
                건강하고 즐겁고 시적인 인생을 표현하고자 합니다. `,
                intromobile: `르쏘넷(LESONNET)은 그린 위에서 즐기는 
                스포티 라이프를 추구하는 브랜드입니다. 
                건강하고 즐겁고 시적인 인생을 
                표현하고자 합니다. `,
                hashtag: '#여성 캐주얼 골프웨어 #레트로 컬러 포인트 #골프 & 테니스 라이프 스타일',
                logoformat: 'svg',
                imagecount: 3,
                ee: {
                    hasee: -1,
                    claimed: false,
                },
                brandshopurl: 'https://www.musinsa.com/brands/lesonnet',
            },
            // {
            //     brandname: 'GOLFBRAND9 ',
            //     brandnamekr:'', intro: 'GOLFBRAND9 ',
            //     intromobile: `LOREM`, hashtag: '반팔티셔츠',
            //     logoformat: 'svg',
            //     imagecount: 3,
            //     ee: {
            //         hasee: -1,
            //         claimed: false,
            //     },
            // },
            // {
            //     brandname: '10 - GOLFBRAND10',
            //     brandnamekr:'', intro: 'GOLFBRAND10 ',
            //     intromobile: `LOREM`, hashtag: '반팔티셔츠',
            //     logoformat: 'svg',
            //     imagecount: 3,
            //     ee: {
            //         hasee: -1,
            //         claimed: false,
            //     },
            // },
        ],
    },
];

export default data;
